import ModelEntity from "../model-entity"
import {EntityType} from "../../gd/const/item"
import ErrorProto from "../../gd/validation/error"
import ErrorFieldRequired from "../../gd/validation/error-field-required"

export enum AiAgentAccess {
    PRIVATE = 1,
    COMPANY = 2,
}

export default class AiAgent extends ModelEntity {

    // id              : ID
    companyId       : ID
    userId          : ID
    name            : string
    description     : string | null
    instructions    : string
    provider        : string | null
    access          : AiAgentAccess
    metadata        : any
    isDeleted       : boolean
    momentCreated   : string

    constructor(data:any) {
        super(data?.id, EntityType.AI_AGENT)
        // this.id             = data['id']
        this.companyId      = data['companyId']
        this.userId         = data['userId']
        this.name           = data['name']
        this.description    = _.get(data, 'description', null)
        this.instructions   = _.get(data, 'instructions', '')
        this.provider       = _.get(data, 'provider', null)
        this.access         = Number(_.get(data, 'access', AiAgentAccess.COMPANY))
        this.metadata       = _.get(data, 'metadata', {})
        this.isDeleted      = _.get(data, 'isDeleted', false)
        this.momentCreated  = data['momentCreated']
    }

    get icon(): string | null {
        return this.metadata?.icon ?? null
    }

    set icon(value: string | null) {
        if (!this.metadata) this.metadata = {}
        this.metadata.icon = value
    }

    get color(): number | null {
        return this.metadata?.color ?? null
    }

    set color(value: number | null) {
        if (!this.metadata) this.metadata = {}
        this.metadata.color = value
    }

    // @deprecated — kept for backward compatibility with existing data
    get image(): string | null {
        return this.metadata?.image ?? null
    }


    canEdit(): boolean {
        if (this.isDeleted) return false
        if (this.userId === gd.user.id) return true
        if (this.access === AiAgentAccess.COMPANY && gd.ac.company.isAdmin()) return true
        return false
    }

    clone() {
        return new AiAgent(this.toJSON())
    }

    validate(): ErrorProto[] | null {
        const errors : ErrorProto[] = []

        if (!this.name) errors.push(new ErrorFieldRequired(gd.fields.aiAgent.name))
        if (!this.instructions) errors.push(new ErrorFieldRequired(gd.fields.aiAgent.instructions))

        return _.isEmpty(errors) ? null : errors
    }

    toJSON(): JSONObject {
        return {
            id              : this.id,
            companyId       : this.companyId,
            userId          : this.userId,
            name            : this.name,
            description     : this.description,
            instructions    : this.instructions,
            provider        : this.provider,
            access          : this.access,
            metadata        : this.metadata,
            isDeleted       : this.isDeleted,
            momentCreated   : this.momentCreated,
        }
    }
}
